(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.trans = this.dataset.trans;
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headersub = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();

      window.matchMedia('(max-width: 992px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.onScroll();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom || scrollTop > this.header.offsetHeight ) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom || scrollTop > this.header.offsetHeight ) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top || scrollTop < this.header.offsetHeight) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.section-header');
  const headerWrapper = document.querySelector('.header-wrapper');
  let headerIsAlwaysSticky = headerWrapper && headerWrapper.dataset.stickyType === 'always' || headerWrapper.dataset.stickyType === 'reduce-logo-size';
  let headerBounds = {};
  let currentScrollTop = 0;

  const onScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (!header) return;
    if (!headerIsAlwaysSticky) {
      if (scrollTop > currentScrollTop && scrollTop > headerBounds.bottom || scrollTop > header.offsetHeight) {
        header.classList.add('not_sticky');
      } else if (scrollTop < currentScrollTop && scrollTop > headerBounds.bottom || scrollTop > header.offsetHeight) {
        header.classList.add('not_sticky');
      } else if (scrollTop <= headerBounds.top || scrollTop < header.offsetHeight) {
        header.classList.remove('not_sticky');
      }
    } 
    currentScrollTop = scrollTop;
  };
  window.addEventListener('scroll', onScroll, false);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kingtool-bfcm"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  const initialized=new WeakSet();
  function init(root){
    if(initialized.has(root))return;initialized.add(root);
    const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
    const dialog=root.querySelector('.ktcVideoDialog'),player=dialog?.querySelector('video'),status=dialog?.querySelector('[data-video-status]');
    root.addEventListener('click',event=>{
      const button=event.target.closest('[data-video-src]');
      if(button&&dialog&&player){player.src=button.dataset.videoSrc;status.textContent='';dialog.showModal();player.play().catch(()=>status.textContent=root.dataset.videoFallback);}
      if(event.target.closest('[data-close-video]'))dialog?.close();
      if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}
    });
    dialog?.addEventListener('close',()=>{player.pause();player.removeAttribute('src');player.load();});
    player?.addEventListener('error',()=>status.textContent=root.dataset.videoError);
    if(!('IntersectionObserver' in window))return;
    const reveal=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');reveal.unobserve(e.target);}}),{threshold:.05});
    root.querySelectorAll('[data-reveal]').forEach(e=>reveal.observe(e));if(!reduced)root.classList.add('is-enhanced');
    const scenes=new IntersectionObserver(()=>{const focus=innerHeight*(root.clientWidth<700?.72:.42);const e=Array.from(root.querySelectorAll('[data-scene]')).sort((a,b)=>{const x=a.getBoundingClientRect(),y=b.getBoundingClientRect();return Math.abs((x.top+x.bottom)/2-focus)-Math.abs((y.top+y.bottom)/2-focus);})[0];if(!e)return;root.querySelectorAll('[data-scene-image]').forEach((image,i)=>{const active=image.dataset.sceneImage===e.dataset.scene;image.classList.toggle('is-active',active);root.querySelectorAll('.ktcSceneProgress i')[i]?.classList.toggle('is-active',active);if(active)root.querySelector('[data-scene-current]').textContent=String(i+1).padStart(2,'0');});},{rootMargin:'-18% 0px -20% 0px',threshold:[0,.1,.2,.3,.4,.5,.6,.7,.8,.9,1]});
    root.querySelectorAll('[data-scene]').forEach(e=>scenes.observe(e));
    root.addEventListener('ktc:cleanup',()=>{reveal.disconnect();scenes.disconnect();dialog?.close();},{once:true});
  }
  function scan(scope){scope.querySelectorAll('[data-ktc-section]').forEach(init);}
  scan(document);
  document.addEventListener('shopify:section:load',e=>scan(e.target));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-ktc-section]').forEach(r=>r.dispatchEvent(new Event('ktc:cleanup'))));
})();

(() => {
  'use strict';
  const initialized = new WeakMap();
  function init(root) {
    if (initialized.has(root) || !('IntersectionObserver' in window)) return;
    const preference = matchMedia('(prefers-reduced-motion: reduce)');
    if (preference.matches) return;
    let frame = 0;
    let active = true;
    const visibleImages = new Set();
    const headings = root.querySelectorAll('.ktcSectionHead h2,.ktcCinema h2,.ktcStep h2,.ktcFaq h2,.ktcClosing h2');
    headings.forEach(heading => {
      let index = 0;
      const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(node => {
        const fragment = document.createDocumentFragment();
        node.textContent.split(/(\s+)/).forEach(word => {
          if (!word.trim()) { fragment.append(document.createTextNode(word)); return; }
          const span = document.createElement('span');
          span.className = 'ktcMotionWord';
          span.style.setProperty('--word-index', Math.min(index++, 10));
          span.textContent = word;
          fragment.append(span);
        });
        node.replaceWith(fragment);
      });
      heading.dataset.textMotion = '';
    });
    const textObserver = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('text-is-visible'); textObserver.unobserve(entry.target); }
    }), { threshold: .22 });
    headings.forEach(heading => textObserver.observe(heading));
    const imageObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => entry.isIntersecting ? visibleImages.add(entry.target) : visibleImages.delete(entry.target));
      schedule();
    }, { rootMargin: '80px 0px' });
    root.querySelectorAll('.ktcHeroProduct>img,.ktcDealImageViewport>img,.ktcBlogImage>img').forEach(image => {
      image.dataset.scrollImage = '';
      imageObserver.observe(image);
    });
    const rail = root.querySelector('[data-scroll-rail]');
    function update() {
      frame = 0;
      if (!active) return;
      const height = innerHeight;
      const mobile = root.clientWidth <= 700;
      visibleImages.forEach(image => {
        const rect = image.parentElement.getBoundingClientRect();
        const progress = Math.max(-1, Math.min(1, (height / 2 - (rect.top + rect.height / 2)) / height));
        image.style.setProperty('--scroll-y', `${(progress * (mobile ? 36 : 18)).toFixed(1)}px`);
        image.style.setProperty('--scroll-scale', (1.025 + Math.abs(progress) * (mobile ? .045 : .02)).toFixed(3));
      });
      if (rail) {
        const rect = rail.parentElement.getBoundingClientRect();
        const progress = Math.max(0, Math.min(1, (height - rect.top) / (height + rect.height)));
        rail.style.transform = `translateX(${-progress * (mobile ? 190 : 100)}px)`;
      }
    }
    function schedule() { if (!frame && active) frame = requestAnimationFrame(update); }
    function onPreferenceChange(event) { if (event.matches) cleanup(); }
    function cleanup() {
      active = false;
      cancelAnimationFrame(frame);
      textObserver.disconnect(); imageObserver.disconnect();
      window.removeEventListener('scroll', schedule); window.removeEventListener('resize', schedule);
      preference.removeEventListener('change', onPreferenceChange);
      root.classList.remove('motion-ready');
    }
    root.classList.add('motion-ready');
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    preference.addEventListener('change', onPreferenceChange);
    root.addEventListener('ktc:cleanup', cleanup, { once: true });
    initialized.set(root, cleanup);
    schedule();
  }
  function scan(scope) { scope.querySelectorAll('.ktc').forEach(init); }
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();


  } catch(e) { console.error(e); }
})();
})();
